
















































import { Component, Vue } from 'vue-property-decorator'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import BuilderAddButton from '@/components/builder/BuilderAddButton.vue'
import BuilderDefaultContainer from '@/components/builder/BuilderDefaultContainer.vue'
import BuilderSidebar from '@/components/builder/BuilderSidebar.vue'
import BuilderButton from '@/components/builder/BuilderButton.vue'
import BuilderTooltip from '@/components/builder/BuilderTooltip.vue'
import StepsNavigation from './components/StepsNavigation.vue'
import AppExamplePromoPage from './components/AppExamplePromoPage.vue'
import BuilderSubscriptionModal from '@/components/builder/BuilderSubscriptionModal.vue'
import { durations, frequencies } from '@/config/subscriptions'

@Component({
  components: {
    BuilderDefaultContainer,
    BuilderTooltip,
    BuilderButton,
    BuilderSidebar,
    StepsNavigation,
    BuilderAddButton,
    BuilderSubscriptionModal,
    AppExamplePromoPage,
  },
  computed: {
    ...mapGetters('buildergpt', ['getCurrentStep', 'getApp']),
  },
  methods: {
    ...mapMutations('buildergpt', ['changeStep', 'setTariffs']),
    ...mapActions('buildergpt', ['saveData']),
  },
})
export default class BuilderGptStep4 extends Vue {
  getApp!: any
  loaded = true
  viewMode = false
  processing = false
  isStartWindow = true
  validationErrors = false
  open = false
  stepData: any = {
    tariffs: [],
    promotionalPage: {
      name: 'SupsterGPT',
    },
  }
  setTariffs!: any

  getCurrentStep!: number
  saveData!: any

  get position() {
    if (this.$breakpoints.desktop) {
      return 0
    }
    if (this.$breakpoints.tablet) {
      return ['top', 170]
    }
    if (this.$breakpoints.mobileSmall) {
      return ['top', 70]
    }
    if (this.$breakpoints.xs) {
      return ['top', 140]
    }
    return 0
  }
  get startWindowPosition() {
    if (this.$breakpoints.desktop) {
      return 0
    }
    if (this.$breakpoints.tablet) {
      return 130
    }
    if (this.$breakpoints.mobileSmall) {
      return 15
    }
    if (this.$breakpoints.xs) {
      return 95
    }
    return 0
  }

  get isHasTarrifs() {
    // return !this.stepData.tariffs.length
    return false
  }
  get isNextStepDisabled() {
    // return !this.stepData.tariffs.some((item: any) => item.price === 0)
    return false
  }

  get frequencies() {
    return Object.keys(frequencies).map((id) => ({
      id: Number(id),
      label: frequencies[Number(id)],
    }))
  }
  get durations() {
    return Object.keys(durations).map((id) => ({
      id: Number(id),
      label: durations[Number(id)],
    }))
  }
  setCurrentTariffs() {
    if (this.getApp.currency === 'RUB') {
      this.setTariffs({
        ...this.getApp,
        tariffs: [
          {
            id: null,
            name: 1,
            price: 690,
            type: 1,
            frequency: 2,
            duration: 1,
          },
          {
            id: null,
            name: 2,
            price: 2100,
            type: 1,
            frequency: 3,
            duration: 1,
          },
          {
            id: null,
            name: 3,
            price: 7990,
            type: 1,
            frequency: 5,
            duration: 1,
          },
        ],
      })
    } else {
      this.setTariffs({
        ...this.getApp,
        tariffs: [
          {
            id: null,
            name: 1,
            price: 7,
            type: 1,
            frequency: 2,
            duration: 1,
          },
          {
            id: null,
            name: 2,
            price: 21,
            type: 1,
            frequency: 3,
            duration: 1,
          },
        ],
      })
    }
  }

  openPopUp() {
    this.open = true
    // if (!this.stepData.tariffs.length) {
    //   this.stepData.tariffs = this.stepData.tariffs
    // }
  }

  async confirmStep(): Promise<void> {
    await this.saveData(this.stepData)
    this.$router.push({ path: `/gpt/step/${this.getCurrentStep}` })
  }

  created() {
    if (!this.getApp.tariffs.length) {
      this.setCurrentTariffs()
      this.stepData.tariffs = this.getApp.tariffs
    } else {
      this.stepData.tariffs = this.getApp.tariffs
    }
  }
}
